var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 103,
    viewBox: "0 0 141 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1437254128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M71.4639 79.0412H47.5V96.713H71.4639V79.0412Z",
    fill: "#2C96D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M115.939 73.4381H3.0243C1.35426 73.4381 0 72.0744 0 70.3919V3.04617C0 1.36405 1.35389 0 3.0243 0H115.938C117.609 0 118.963 1.36368 118.963 3.04617V70.3919C118.963 72.0744 117.609 73.4381 115.939 73.4381Z",
    fill: "#2C96D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M115.426 80.7656H3.53659C1.58332 80.7656 0 78.8855 0 76.5665V65.6799H118.962V76.5665C118.962 78.8855 117.379 80.7656 115.426 80.7656Z",
    fill: "#0071BC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M113.18 65.4134H5.78586C5.42726 65.4134 5.13672 65.1207 5.13672 64.7596V5.72494C5.13672 5.36375 5.42726 5.07111 5.78586 5.07111H113.18C113.539 5.07111 113.829 5.36375 113.829 5.72494V64.7599C113.829 65.1207 113.539 65.4134 113.18 65.4134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.81,
    d: "M105.656 61.3694H13.3093C12.9507 61.3694 12.6602 61.0768 12.6602 60.7156V10.0348C12.6602 9.67364 12.9507 9.381 13.3093 9.381H105.656C106.014 9.381 106.305 9.67364 106.305 10.0348V60.7156C106.305 61.0768 106.014 61.3694 105.656 61.3694Z",
    fill: "#ECF1F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M59.4801 77.7169C57.0786 77.7169 55.125 75.7488 55.125 73.3303C55.125 70.9118 57.0786 68.944 59.4801 68.944C61.8817 68.944 63.8353 70.9118 63.8353 73.3303C63.8353 75.7488 61.8813 77.7169 59.4801 77.7169ZM59.4801 69.3122C57.2803 69.3122 55.4909 71.1149 55.4909 73.3299C55.4909 75.5457 57.2806 77.348 59.4801 77.348C61.68 77.348 63.4694 75.5454 63.4694 73.3299C63.4694 71.1145 61.68 69.3122 59.4801 69.3122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M84.9427 99.7302H34.0195V98.9806C34.0195 96.5381 35.9856 94.5578 38.4105 94.5578H80.5513C82.9763 94.5578 84.9423 96.5381 84.9423 98.9806V99.7302H84.9427Z",
    fill: "#0071BC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.47,
    d: "M113.18 11.2478H5.78586C5.42726 11.2478 5.13672 10.9552 5.13672 10.594V5.72451C5.13672 5.36332 5.42726 5.07068 5.78586 5.07068H113.18C113.539 5.07068 113.829 5.36332 113.829 5.72451V10.594C113.829 10.9552 113.539 11.2478 113.18 11.2478Z",
    fill: "#0071BC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M103.406 8.06096C103.406 8.37166 103.156 8.62338 102.847 8.62338C102.539 8.62338 102.289 8.37166 102.289 8.06096C102.289 7.75026 102.539 7.49854 102.847 7.49854C103.156 7.4989 103.406 7.75063 103.406 8.06096Z",
    fill: "#ECF1F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M109.363 8.06096C109.363 8.37166 109.113 8.62338 108.804 8.62338C108.496 8.62338 108.246 8.37166 108.246 8.06096C108.246 7.75026 108.496 7.49854 108.804 7.49854C109.113 7.49854 109.363 7.75063 109.363 8.06096Z",
    fill: "#ECF1F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M105.828 8.62338C106.136 8.62338 106.386 8.37158 106.386 8.06096C106.386 7.75034 106.136 7.49854 105.828 7.49854C105.52 7.49854 105.27 7.75034 105.27 8.06096C105.27 8.37158 105.52 8.62338 105.828 8.62338Z",
    fill: "#ECF1F7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.21,
    d: "M80.3193 66.975C94.4107 66.975 105.834 55.4691 105.834 41.2758C105.834 27.0826 94.4107 15.5767 80.3193 15.5767C66.228 15.5767 54.8047 27.0826 54.8047 41.2758C54.8047 55.4691 66.228 66.975 80.3193 66.975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    opacity: 0.81,
    d: "M82.9915 31.3207C85.9647 30.6453 87.8314 27.67 87.1609 24.6753C86.4904 21.6805 83.5365 19.8003 80.5632 20.4757C77.59 21.1511 75.7233 24.1264 76.3938 27.1211C77.0644 30.1159 80.0182 31.9961 82.9915 31.3207Z",
    fill: "#ECF1F7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.58,
    d: "M80.3207 67.7122C65.8483 67.7122 54.0742 55.8526 54.0742 41.2759C54.0742 26.6992 65.8487 14.8396 80.3207 14.8396C94.7927 14.8396 106.567 26.6988 106.567 41.2759C106.567 55.8529 94.7931 67.7122 80.3207 67.7122ZM80.3207 16.3138C66.6552 16.3138 55.5379 27.5119 55.5379 41.2759C55.5379 55.0402 66.6555 66.2379 80.3207 66.2379C93.9858 66.2379 105.104 55.0399 105.104 41.2759C105.104 27.5115 93.9858 16.3138 80.3207 16.3138Z",
    fill: "#2C96D4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M121.157 77.7536L104.346 61.1672C104.015 60.8406 103.636 60.5955 103.232 60.4267C107.517 55.2318 110.095 48.5575 110.095 41.2758C110.095 24.713 96.7651 11.2862 80.3212 11.2862C63.8772 11.2862 50.5469 24.713 50.5469 41.2758C50.5469 57.8387 63.8772 71.2654 80.3212 71.2654C87.2037 71.2654 93.5355 68.907 98.5778 64.9575C98.7535 65.4281 99.0279 65.8693 99.4077 66.2445L116.219 82.8309C116.906 83.5084 117.797 83.846 118.688 83.846C119.603 83.846 120.517 83.4896 121.208 82.779C122.572 81.377 122.549 79.1269 121.157 77.7536ZM54.8069 41.2762C54.8069 27.0828 66.2301 15.577 80.3215 15.577C94.413 15.577 105.836 27.0828 105.836 41.2762C105.836 55.4696 94.413 66.9754 80.3215 66.9754C66.2301 66.9754 54.8069 55.4692 54.8069 41.2762Z",
    fill: "#2C96D4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M139.135 92.0503L114.674 67.4122C114.065 66.7986 105.034 75.8442 105.669 76.4829L130.13 101.121C132.617 103.626 136.649 103.626 139.135 101.121C141.622 98.6162 141.622 94.555 139.135 92.0503ZM137.289 96.228C137.289 97.4726 136.288 98.4814 135.052 98.4814C133.816 98.4814 132.814 97.4726 132.814 96.228C132.814 94.9833 133.816 93.9746 135.052 93.9746C136.287 93.9742 137.289 94.9833 137.289 96.228Z",
    fill: "#0071BC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M136.287 98.1062C135.933 98.3429 135.508 98.4814 135.052 98.4814C133.816 98.4814 132.814 97.4727 132.814 96.228C132.814 95.7401 132.97 95.2897 133.232 94.9208C127.648 89.1078 119.407 80.5638 114.436 75.4193C111.868 72.762 110.174 71.0121 110.17 71.0154C107.75 73.4011 105.33 76.1421 105.669 76.4834L130.13 101.121C132.616 103.626 136.649 103.626 139.135 101.121C139.148 101.108 138.054 99.9535 136.287 98.1062Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M116.014 68.9749L107.184 77.868C106.781 78.2745 106.127 78.2745 105.723 77.868L104.131 76.264C103.727 75.8575 103.727 75.1989 104.131 74.7923L112.96 65.8993C113.364 65.4927 114.018 65.4927 114.421 65.8993L116.014 67.5033C116.417 67.9098 116.417 68.5688 116.014 68.9749Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWork);
export default __webpack_public_path__ + "static/media/noWork.9a3e2d9f0c1efcab0cc9189e21fc41e6.svg";
export { ForwardRef as ReactComponent };